import { render } from "./SpecialityButton.vue?vue&type=template&id=c7e5adc2&ts=true"
import script from "./SpecialityButton.vue?vue&type=script&lang=ts"
export * from "./SpecialityButton.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__